import {
    View,
    Text
} from "react-native"; const MemberEdit = () => <View><Text>MemberEdit</Text></View>; export default MemberEdit;
